const englishTranslation = {
  translation: {
    "Your gift": "your gift",
    "Donor info": "donor info",
    Payment: "payment",
    "Beat as one": "Beat as one.",
    "Help Rally":
      "Help rally the best scientific minds around critical heart and brain issues, many on the verge of significant breakthroughs. All with one goal: Beat heart disease and stroke.",
    "Give now": "Please give now",
    Address:
      "Heart and Stroke Foundation of Canada\n1200-2300 Yonge St, Box 2414\nToronto, ON M4P1E4\n1-888-473-4636\ndonorinfo@heartandstroke.ca\nMonday to Friday: 9am - 8pm\nSaturday: 9am - 5pm",
    "Privacy policy": "Privacy Policy",
    "Terms of use": "Terms of Use",
    "Heart and Stroke Researcher": "Heart and Stroke Researcher",

    // GOS
    "Institution Info": "Institution Info",
    Securities: "Securities",
    "Institution details": "Institution details",
    "Securities to donate": "Securities to donate",
    Security: "Security",
    Remove: "Remove",
    "Add another security": "Add another security (up to five)",
    "Donor information": "Donor information",
    "How are your investments managed?": "How are your investments managed?",
    "I manage myself": "I manage my investments myself",
    "Self directed platforms subtitle":
      "Use this path for self-directed platforms such as RBC Direct Investing, Wealthsimple, Questrade, or similar.",
    "Managed by advisor": "My investments are managed by an advisor",
    "Advisor managed subtitle":
      "Use this path when a financial advisor, broker, associate, or support team member is involved.",
    "GOS Disclaimer":
      "Donating securities - such as stocks, bonds, or mutual funds - is a simple and tax-efficient way to support Heart & Stroke. \n\nTo get started, complete the online form below. A copy of the completed form will be sent to you. If you are working with an advisor, they will also receive a copy and can work with you to initiate the transfer. \n\nPlease note that submitting this form does not complete your donation. To finalize your gift, you must contact your broker or investment advisor or initiate the transfer through your own direct investing platform.",
    "Account holder disclaimer":
      "The account holder will need to contact the financial institution that holds their self-directed account and provide the necessary transfer instructions to initiate the transfer.",
    "Please Note": "Please Note",
    "Broker information": "Broker information",
    "Contact information": "Contact information",
    "Brokerage / financial institution": "Brokerage / financial institution",
    "Transfer securities from account": "Transfer securities from account #",
    "Advisor First Name": "Advisor First Name",
    "Advisor Last Name": "Advisor Last Name",
    "Advisor phone number": "Advisor phone number",
    "Advisor email": "Advisor email",
    "At least one field must be provided (# or value)": `**At least one of "# of Units / Shares" or "Approximate Dollar Value" must be provided - both are not mandatory.`, // eslint-disable-line
    "Self-directed platform": "Self-directed platform",
    "CUSIP / symbol": "CUSIP / symbol",
    "Security type": "Security type",
    "# of units / shares": "# of units / shares",
    "Security name": "Security name",
    "Approximate dollar value": "Approximate dollar value",
    "Securities successfully processed":
      "Your securities gift has been successfully processed. Thank you for your generous support!",
    Stocks: "Stocks",
    Bonds: "Bonds",
    ETFs: "ETFs",
    "Mutual Fund": "Mutual Fund",

    // Donation type
    "What type of gift": "What type of gift would you like to give?",
    "Choose gift amount": "Choose your gift amount",
    "Who are you honouring by Giving in Memory?":
      "Who are you honouring by Giving in Memory?",
    "Give in memory of your loved one": "Give in memory of your loved one",
    "Win platinum Maple Leafs tickets":
      "Win platinum Maple Leafs tickets for March 12, 2026",
    "one-time": "One-time",
    monthly: "Monthly",
    "one-time-payment": "one-time",
    "monthly-payment": "monthly",
    "in-honour": "In Honour",
    "in-memory": "In Memory",
    "in-honour-payment": "in honour",
    "in-memory-payment": "in memory",
    "Honour Gift Type": "Honour Gift Type",
    "Honouree Name": "Honouree Name",
    "Honouree First Name": "Honouree First Name",
    "Honouree Last Name": "Honouree Last Name",
    "What is your relationship to the Honouree?":
      "What is your relationship to the Honouree?",
    "Close family or friend": "Close family or friend",
    "Extended family or friend": "Extended family or friend",
    Acquaintance: "Acquaintance",
    "Recipient First Name": "Recipient First Name",
    "Recipient Last Name": "Recipient Last Name",
    "Tribute Card Type": "Tribute Card Type",
    "Your personal message": "Your personal message",
    "Card will be blank": " (card will be blank, if not completed)",
    "No Card": "No Card",
    "Send an eCard": "Send an eCard",
    "Mail a card": "Mail a card on my behalf",
    "Duplicate ecard checkbox": "Yes, send me a copy of eCard.",
    Other: "Other",
    "Next Step": "Next Step",
    Continue: "Continue",
    "In Honour Gift Checkbox": "Yes, this is an In Honour or In Memory gift.",
    "Recipient's Email": "Recipient Email Address",
    "eCard Subject": "eCard Subject",
    "Email Subject Line": "Email Subject Line",
    "Full Name": "Full Name",
    "Select card": "Please select one of the cards",
    "Footer Text":
      "Heart and Stroke Foundation of Canada Charitable Registration Number: 10684-6942-RR0001\n\nHeart and Stroke Foundation of New Brunswick Charitable Registration Number: 11924-6940-RR0001\n\n\u2122The heart and / Icon on its own and the heart and / Icon followed by another icon or words in English or French are trademarks of the Heart and Stroke Foundation of Canada.\n\n© {{year}} Heart and Stroke Foundation of Canada. All rights reserved.",
    "Honouree Street Address": "Street Address",
    "Honouree City": "City",
    "Honouree State / Province": "Province / State",
    "Honouree Postal": "Postal / Zip Code",
    "Honouree Country": "Country",
    "Default in-memory ecard message":
      "Deepest condolences during this difficult time.",
    "Default tribute subject": "A donation has been made in tribute of",
    "Would like send ecard": "Would you Like to send an eCard?",
    Matched: "Matched",

    // Donor Info
    "Provide your info": "Donor Information",
    "Required info": "Required Information",
    "Company gift": "Company gift",
    "Company Name": "Company Name",
    Title: "Title",
    "First Name": "First Name",
    "Last Name": "Last Name",
    "Street Address": "Street Address",
    City: "City",
    "State / Province": "Province / State",
    Postal: "Postal / Zip Code",
    Country: "Country",
    "Address 2": "Address 2",
    "Phone Number": "Phone Number",
    "Email Address": "Email Address",
    "Send Monthly Tips":
      "Yes! Please send me monthly health tips, research updates and more.",
    Back: "Back",

    // Overlay Navigation
    "Enter your details": "Enter your details",
    "Make a donation": "Make a donation",
    "Payment details": "Payment details",

    // Thank you page
    "thank you for gift": "thank you for your generous gift",
    "thank you for donation": "Thank you for your donation",
    "Together, we'll": "Together, we'll",
    beat: "beat",
    "heart disease and stroke": "heart disease and stroke.",
    "Thank you for giving in memory":
      "Thank you for Giving in Memory of your loved one with a generous gift today.",
    "Together, we will beat heart disease and stroke":
      "Together, we will beat heart disease and stroke.",
    "thank you for supporting breakthrough":
      "Thank you for supporting breakthrough research that continues to advance the prevention, diagnosis, and treatment of heart disease and stroke.",
    "tax receipt":
      "You will receive your official tax receipt shortly in your inbox. If you have any questions or concerns please contact us at",
    "Please expect your set of premium luggage tags to be mailed to you by early January 2026.":
      "Please expect your set of premium luggage tags to be mailed to you by early January 2026.",
    "Thank you for advancing heart and stroke research in Canada.":
      "Thank you for advancing heart and stroke research in Canada.",
    "dev form tax receipt":
      "You will get official tax receipt in the next few business days. If you have any questions or concerns please contact us at",
    "See the impact": "See the impact of your gift",
    "Start a new donation": "Start a new donation",
    "Your confirmation number": "Your confirmation number is:",
    "Confirmation number": "Confirmation number",
    "TY researcher name":
      "{{researcherSex}} {{researcherName}}, Heart & Stroke Researcher",
    "Together, we will beat":
      "Together, we will beat heart disease and stroke.",
    "Doctor (female)": "Dr.",
    "Doctor (male)": "Dr.",
    "donorinfo@heartandstroke.ca": "donorinfo@heartandstroke.ca",

    // Error messsages
    "Select gift type": "Please select the gift type",
    "Select gift amount": "Please select the gift amount",
    "Enter correct amount": "Please enter correct amount",
    "Enter honouree name": "Please enter honouree name",
    "Enter honouree first name": "Please enter honouree first name",
    "Enter honouree last name": "Please enter honouree last name",
    "Enter recipient first name": "Please enter recipient first name",
    "Enter recipient last name": "Please enter recipient last name",
    "Select honour gift type": "Please select honour gift type",
    "Enter company name": "Please enter company name",
    "Select title": "Please select title",
    "Enter first name": "Please enter first name",
    "Enter last name": "Please enter last name",
    "Enter street address": "Please enter street address",
    "Enter postal": "Please enter postal",
    "Enter city": "Please enter city",
    "Select State / Province": "Please select State / Province",
    "Select State / Province Input": "Please enter State / Province",
    "Select country": "Please select country",
    "Enter email": "Please provide email",
    "Select platform": "Please select platform",
    "Select brokerage": "Please select brokerage",
    "Select management type": "Please select management type",
    "Enter security name": "Please enter security name",
    "Select security type": "Please select security type",
    "Enter CUSIP / symbol": "Please enter CUSIP / symbol",
    "Enter number of units / shares or approximate dollar value":
      "Please enter number of units / shares or approximate dollar value",
    "Enter approximate dollar value or number of units / shares":
      "Please enter approximate dollar value or number of units / shares",
    "Enter account number": "Please enter account number",
    "Enter advisor first name": "Please enter advisor first name",
    "Enter advisor last name": "Please enter advisor last name",
    "Provide valid email": "Please provide a valid email",
    "Provide valid email or select checkbox":
      "Please provide a valid email or select the checkbox below",
    "Enter recipient email": "Please enter recipient email",
    "Enter full name": "Please enter full name",
    "Card recipient info": "Card recipient information",
    "Provide ecard subject": "Please provide ecard subject",
    "Provide email subject": "Please provide email subject",
    "Provide personal message": "Please provide personal message",
    "More than 5": "Minimum $5 donation required",
    "First name greater than 1": "First name length should be greater than 1",
    "First name less than 50": "First name length should be less than 50",
    "Last name greater than 1": "Last name length should be greater than 1",
    "Last name less than 50": "Last name length should be less than 100",
    "Subject greater than 4": "eCard Subject length should be greater than 4",
    "Loyalty card equal 9": "Please provide a 9 digit number",
    "Loyalty card numbers do not match": "Loyalty card numbers do not match",
    "Invalid phone number": "Please enter valid phone number",
    "Enter appeal package": "Please enter appeal package",
    "Enter appeal source": "Please enter appeal source",
    "Enter Call Centre Call Number": "Please Enter Call Centre Call Number",
    "Enter Call Centre Agent Name": "Please Enter Call Centre Agent Name",
    "Select appeal code": "Please select Appeal Code",
    "Enter Appeal Code": "Please Enter Appeal Code",
    "Select processing date": "Please select processing date",
    "Institution number 3 digits": "Institution number must be 3 digits",
    "Transit number 5 digits": "Transit number must be 5 digits",
    "Account number 5 digits": "Account number must be at least 5 digits",
    "Verified account number 5 digits":
      "Verified account number must be at least 5 digits",
    "Account numbers do not match": "Account numbers do not match",
    "Invalid CRM ID": "Please enter valid CRM ID",
    "Invalid company name number only": "Company name can not be numbers only",

    // Payment info
    "Complete payment info": "Complete payment information",
    "Complete Donation": "Complete Donation",
    "You will be making a": "You will be making a",
    "donation of": "donation of",
    "Agree to charge credit card":
      "By checking this option, I agree to use my credit card as a payment method and authorize this organization to charge my credit card account to fulfill my donation commitment.",
    "Agree to cover fee":
      "I'd like my donation to go further and will cover the transaction processing fee.",
    "3% fee tooltip":
      "Processing fee is 3% of your donation amount, up to a maximum of $50.",
    "Did you know you can cover fees":
      "Did you know that by helping offset the processing fee, we’ll be able to do more with your donation?",
    "Would like cover fees":
      "Would you like to cover the $2.00 processing fee for your donation?",
    Loading: "Loading...",
    "Credit Card": "Credit Card",
    "Bank Withdrawal": "Bank Withdrawal",
    "Your monthly gift process":
      "Your future monthly gifts will be processed on the {{date}}{{afterNumber}} of each month, starting {{fullDate}}.",
    "One time terms":
      "By completing this step, you allow the Heart and Stroke Foundation of Canada to use your card information to fulfill your donation.",
    "Monthly terms card":
      "{{actionText}}, I agree to use my credit card as a payment method and authorize this organization to charge my credit card account to fulfill my donation commitment.",
    "By submitting this form": "By submitting this form",
    "By checking this option": "By checking this option",
    "Monthly terms debit":
      "{{actionText}}, I agree to use my bank account as a payment method and authorize this organization to debit my bank account to fulfill my donation commitment.",
    "starting today": ", starting today.",
    Donate: "Donate",
    Total: "Total",
    month: "month",
    "Processing date": "Processing date",
    "1st": "1st",
    "15th": "15th",

    // Debit Form
    "Institution number": "Institution number (3 numeric characters)",
    "Institution number overlay": "Institution number",
    "Transit number": "Transit number (5 numeric characters)",
    "Transit number overlay": "Transit number",
    "Account number": "Account number (5-12 numeric characters)",
    "Verify account number": "Verify account number (5-12 numeric characters)",

    // Provinces
    Alberta: "Alberta",
    "British Columbia": "British Columbia",
    Manitoba: "Manitoba",
    "New Brunswick": "New Brunswick",
    Newfoundland: "Newfoundland and Labrador",
    "Nova Scotia": "Nova Scotia",
    Northwest: "Northwest Territories",
    Nunavut: "Nunavut",
    Ontario: "Ontario",
    "Prince Edward": "Prince Edward Island",
    Quebec: "Quebec",
    Saskatchewan: "Saskatchewan",
    Yukon: "Yukon",

    // Aeroplan
    "Are you aeroplan": "Are you an Aeroplan member?",
    "Get points":
      "Get 4 Aeroplan points for every $1 you donate to the Heart and Stroke Foundation!*",
    "9-digit number": "(9-digit number)",
    "Aeroplan number": "Aeroplan number",
    "Confirm aeroplan number": "Confirm Aeroplan number",
    "Aeroplan Footer":
      "\n*Offer available until January 31, 2023. Earn 4 Aeroplan points for every $1 donated through this donation page to the Heart and Stroke Foundation, up to a maximum of 2,500 bonus points per transaction for CRA regulation compliance. Please allow up to 6-8 weeks for points to be posted to your account.",

    // Popup
    "Something went wrong": "Something went wrong. Please try again",
    "Please correct your donation information":
      "Please correct your donation information, as indicated on the form before proceeding.",
    "Welcome back":
      "Welcome back{{firstName}}. Thanks for your support. We have prefilled some of the form information for you.",
    "Incorrect card": "Please provide correct credit card details.",
    "Technical difficulties":
      "We are experiencing some technical difficulties. Please try again later.",
    "Agree to terms": "Please agree to the terms in order to continue",
    "Process request": "Please wait as we process your request",
    "Session timeout": "Your session has timed out. Please reload the page",
    "Session time left": "Your session is ending in {{sessionTimeLeft}}",
    "Stay connected": "Stay connected",
    Reload: "Reload",
    "Can't process request":
      "Sorry, we can not process request at the moment. Please try again later",

    // Call Center
    "Recording on": "Turn on recording",
    "Recording off": "Turn off recording",
    "Donor's language French":
      "If Donor's language preference is French, switch to FR now",
    "Receipts blurb":
      "We offer receipts by email as this is the fastest and more efficient delivery method. Please provide your email address so we can send your receipt.",
    "Print receipt requested": "Print receipt requested",
    "Donor does not have an email address":
      "Donor does not have an email address",
    "Contact Centre Call Number": "Contact Centre Call Number",
    "Agent First Name and Last Initial": "Agent First Name and Last Initial",
    "Appeal Source": "Appeal Source (max 6 chars)",
    "Appeal Package": "Appeal Package (max 5 chars)",
    "CRM ID": "CRM ID",
    "Appeal Code": "Appeal Code",
    "Tribute Report": "Tribute Report Request",
    "Funeral Home Materials": "Funeral Home Materials",
    "Valid email address":
      "Please enter a valid email address in order to receive your official tax receipt.",

    // Error page
    "We have run into issues": "Apologies, we have run into some issues.",
    "Call center agents":
      "You can also contact our Call Center agents, they would help process your donation by phone. Call us at ",

    // Titles
    Mr: "Mr.",
    Ms: "Ms.",
    Mrs: "Mrs.",
    Miss: "Miss",
    Dr: "Dr.",

    // Booleans
    Yes: "Yes",
    No: "No",
  },
};

export default englishTranslation;
